import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import { InputField, ReactSelectCreateAble } from "../../../../../atoms/FormElement";
import { ReactSelectField } from "../../../../../atoms/FormElement";
import { useUpdateBankInfo } from "../../../hooks/useUpdateBankInfo";
import { useSelector } from "react-redux";
import AddOwner from "../../../../Owner/AddOwner";
import Title from "antd/es/typography/Title";
import { Popup } from "../../../../../atoms/Popup";
import { useApiWithFilters } from "../../../../../../hooks/search/useApiWithFilters";
import { getBeneficiaries } from "../../ducks/actions/getOwner";
import { InputNumberFieldV2 as InputNumberField } from "../../../../../atoms/FormElement/InputNumberField";

var _ = require("lodash");

export default (props) => {
  const {
    control,
    ownerInitial,
    noEdit,
    setValue,
    benificiaryInitial,
    setBenificiaryInitail,
    setBankNameInitial,
    bankNameInitial,
    setOwnerInitail,
    bankList,
  } = props;
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [ownerFetch, setOwnerFetch] = useState(false);
  const [beneficiariesOptions, setBeneficiaryOptions] = useState(null);

  const { data: result, fetchData } = useApiWithFilters({
    apiUrl: "/property/owner",
    method: "GET",
    initialParams: { limit: 20000, page: 1 },
  });

  useEffect(() => {
    fetchData(); // initial load
  }, [ownerFetch]);

  const [beneficiaryValue, setBeneficiaryValue] = useState(null);
  const configData = useSelector((state: any) => state.dashboard.configData);

  useUpdateBankInfo(
    bankList,
    beneficiaryValue,
    setValue,
    setBankNameInitial,
    beneficiariesOptions,
    setBenificiaryInitail,
  );

  const popup = [
    {
      title: (
        <Title level={3} className="m-0">
          Add New Owner
        </Title>
      ),
      content: (
        <AddOwner
          setVisible={setVisible}
          ownerInitial={ownerInitial}
          setOwnerFetch={setOwnerFetch}
          editAbleRecord={undefined}
          ownerFetch={ownerFetch}
        />
      ),
      width: 1150,
      style: { padding: "0px" },
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    style: popup[trigger]?.style,
    onCancel: () => setVisible(false),
  };

  const getBeneficiariesOption = async (ownerId) => {
    let scope: string | null = "limited";
    const data = await getBeneficiaries(ownerId, scope);

    if (data?.length > 0) {
      let result = _.map(data, (item) => ({
        value: item?.beneficiaryId,
        label: item?.beneficiaryName,
        beneficiaryBank: item?.beneficiaryBank,
        beneficiaryAccountNumber: item?.beneficiaryAccountNumber,
        beneficiaryIBAN: item?.beneficiaryIBAN,
      }));

      let updateResult = result?.length > 0 ? result : [];
      setBeneficiaryOptions(updateResult);
    } else {
      setBeneficiaryOptions([]);
    }
  };

  useEffect(() => {
    if (ownerInitial && ownerInitial?.ownerId) {
      getBeneficiariesOption(ownerInitial?.ownerId);
    }
  }, [ownerInitial?.ownerId]);

  const onChangeOwner = async (e) => {
    setOwnerInitail(e);
    setBenificiaryInitail({ value: "", label: "" });
    setBankNameInitial({ value: "", label: "" });
    setValue("ownerNumber", e?.ownerNumber);
    const matchedNationality = configData?.nationalityList?.find(
      (nat) => nat?.toLowerCase() === e?.ownerNationality?.toLowerCase(),
    );
    setValue("beneficiaryName", "");
    setValue("bankName", null);
    setValue("accountNo", "");
    setValue("iban", "");
    matchedNationality && setValue("ownerNationality", { label: matchedNationality, value: matchedNationality });
  };

  return (
    <Row gutter={24}>
      <Col span={6}>
        <ReactSelectField
          isRequired={false}
          disable={true}
          label="Nationality"
          fieldname="ownerNationality"
          menuPlacement={"top"}
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          setValue={setValue}
          initValue=""
          iProps={{
            placeholder: "Select Nationality",
            isDisabled: true,
            className: `${"disablerselect"}`,
          }}
          selectOption={_.map(configData?.nationalityList, (item) => ({
            value: item,
            label: item,
          }))}
        />
      </Col>

      <Col span={6}>
        <ReactSelectCreateAble
          isClearable={true}
          options={_.map(result?.result?.data, (item) => ({
            value: item?.name,
            label: item?.name,
            ownerNumber: item?.number,
            ownerNationality: item?.nationality,
            ownerId: item?.ownerId,
          }))}
          onChange={(e) => onChangeOwner(e)}
          initalValue={ownerInitial}
          isRequired={false}
          label="Owner Name"
          fieldname="ownerName"
          control={control}
          setValue={setValue}
          onCreateOption={(e) => {
            // setOwnerInitail({ label: e, value: e });
            setValue("beneficiaryName", { value: "", label: "" });
            setValue("bankName", { value: "", label: "" });
            setValue("accountNo", "");
            setValue("iban", "");
            setVisible(true);
            setTrigger(0);
          }}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          iProps={{
            placeholder: "Select Owner Name",
            isDisabled: noEdit,
            className: `${noEdit ? "disablerselect" : ""}`,
            menuPlacement: "top",
          }}
        />
      </Col>
      <Col span={6}>
        <InputField
          isRequired={false}
          label="Owner No"
          fieldname="ownerNumber"
          control={control}
          classes={"noEditLabel"}
          initValue=""
          iProps={{
            placeholder: "Owner Number",
            readOnly: true,
            disabled: true,
            type: "number",
            className: `${noEdit ? "noEdit" : ""}`,
          }}
        />
      </Col>
      <Col span={6}>
        <ReactSelectField
          isRequired={false}
          menuPlacement={"top"}
          label="Beneficiary Name"
          fieldname="beneficiaryName"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          initValue={benificiaryInitial}
          iProps={{
            placeholder: "Select Beneficiary Name",
            isDisabled: noEdit,
            className: `${noEdit ? "disablerselect" : ""}`,
          }}
          selectOption={beneficiariesOptions}
          setValue={setValue}
          valueGot={benificiaryInitial}
          onChange={(e) => setBeneficiaryValue(e)}
        />
      </Col>
      <Col span={6}>
        <ReactSelectField
          isRequired={false}
          label="Bank"
          fieldname="bankName"
          // disabled={true}
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          initValue={bankNameInitial}
          iProps={{
            placeholder: "Select Bank",
            isDisabled: true,
            className: `${noEdit ? "disablerselect" : ""}`,
            menuPlacement: "top",
          }}
          setValue={setValue}
          valueGot={bankNameInitial}
          selectOption={bankList}
          onChange={(e) => setBankNameInitial(e)}
        />
      </Col>

      <Col span={6}>
        <InputNumberField
          label="Account No"
          fieldname="accountNo"
          disabled={true}
          control={control}
          inputNumberProps={{
            placeholder: "Account No",
            readOnly: noEdit,
            className: noEdit ? "noEdit" : "",
          }}
        />
      </Col>
      <Col span={6}>
        <InputField
          //   isRequired={!noEdit}
          label="IBAN"
          fieldname="iban"
          disabled={true}
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          initValue=""
          setValue={setValue}
          iProps={{
            placeholder: "IBAN",
            readOnly: false,
            className: `${noEdit ? "noEdit" : ""}`,
          }}
        />
      </Col>
      <Popup destroyOnClose={true} {...popupProps} />
    </Row>
  );
};
